import { Stack } from 'component-library';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { IndicatorProduct } from '@/api/rest/resources/types/IndicatorProduct';
import { IndicatorProductCard } from '@/components/widgets/o/IndicatorLibraryCard/IndicatorLibraryCard';
import {
  useNewIndicatorProducts,
  useSelectedIndicatorProducts,
} from '@/pages/shared/indicators/hooks/useIndicatorProducts';

const IndicatorSectionLayout = ({ children, dataTestid }: { children: ReactNode; dataTestid?: string }) => {
  return <Stack data-testid={dataTestid}>{children}</Stack>;
};

export const SelectedIndicators = () => {
  const { t } = useTranslation();

  const indicatorProducts = useSelectedIndicatorProducts();

  return (
    <IndicatorSectionLayout dataTestid='selected-indicators-section'>
      <span className='typography-h3 text-text-primary'>{t('indicators.selectedIndicators.title')}</span>
      {indicatorProducts.length > 0 ? (
        <IndicatorProducts indicatorProducts={indicatorProducts} />
      ) : (
        <span className='my-4 items-center typography-body1 text-text-secondary'>{t('indicators.emptySection')}</span>
      )}
    </IndicatorSectionLayout>
  );
};

export const NewIndicators = () => {
  const { t } = useTranslation();

  const indicatorProducts = useNewIndicatorProducts();

  return (
    <IndicatorSectionLayout dataTestid='new-indicators-section'>
      <span className='typography-h3 text-text-primary'>{t('indicators.newIndicators.title')}</span>
      {indicatorProducts.length > 0 ? (
        <IndicatorProducts indicatorProducts={indicatorProducts} />
      ) : (
        <span className='my-4 items-center typography-body1 text-text-secondary'>{t('indicators.emptySection')}</span>
      )}
    </IndicatorSectionLayout>
  );
};

type IndicatorSectionProps = {
  indicatorProducts: IndicatorProduct[];
};

const IndicatorProducts = ({ indicatorProducts }: IndicatorSectionProps) => {
  return (
    <Stack direction='row' spacing={6} className='flex-wrap w-full py-5'>
      {indicatorProducts.map((indicatorProduct) => (
        <div key={`${indicatorProduct.name}/${indicatorProduct.widget.type}`}>
          <IndicatorProductCard indicatorLibraryCard={indicatorProduct} />
        </div>
      ))}
    </Stack>
  );
};
